import { Component, OnInit } from '@angular/core';
import { ModalController, LoadingController } from '@ionic/angular';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { GlobalService } from '../global.service';
import { resolve } from 'q';
import { map, catchError } from 'rxjs/operators';
import { SelectLifepathPage } from '../select-lifepath/select-lifepath.page';
@Component({
  selector: 'app-lifepath',
  templateUrl: './lifepath.page.html',
  styleUrls: ['./lifepath.page.scss'],
})
export class LifepathPage implements OnInit {

    dataset = null;
    character = GlobalService.CHARACTER;
    constructor(private modalController: ModalController, public http: HttpClient, private globalService: GlobalService, private loadingController: LoadingController) { }


    ngOnInit() {
        if (GlobalService.JSON_LIFEPATH == null) {
            this.load();
        }
        else {
            this.dataset = GlobalService.JSON_LIFEPATH;
        }
    }

    async load() {
        const loading = await this.loadingController.create({
            message: '',
            spinner: 'crescent'
        });
        await loading.present();
        return new Promise(resolve => {
            this.http.get("./../assets/data/lifepath.json").
                pipe(map(
                    (response) => JSON.parse(JSON.stringify(response))
                )).
                subscribe(
                    (data) => {
                        {
                            loading.dismiss();
                            this.dataset = data;
                            GlobalService.JSON_LIFEPATH = data;
                            resolve(this.dataset);
                        }
                    }
                )

        });
    }

    randomProp(prop, amount=null) {
        if (amount != null) {
            this.character.lifepath[prop] = [];
            if (amount > 0) {
                var arr = [];
                for (var i = 0; i < amount; i++) {
                    var value = this.dataset[prop][GlobalService.Roll(this.dataset[prop].length - 1)];
                    arr.push(value);
                    this.character.lifepath[prop] = arr;
                }
            }
        }
        else {
            var value = this.dataset[prop][GlobalService.Roll(this.dataset[prop].length - 1)];
            this.character.lifepath[prop] = value;
        }
    }
    removeOption(prop, idx) {
        this.character.lifepath[prop].splice(idx, 1);
    }
    randomAll() {
        this.randomProp("background");
        this.randomProp("motivation");
        this.randomProp("goals");
        this.randomProp("romance");
        this.randomProp("personality");
        this.randomProp("friends", GlobalService.Roll(10)-7);
        this.randomProp("enemies", GlobalService.Roll(10) - 5);
    }

    randomize(prop, rollmod = null) {
        console.log(prop, rollmod);
        if (rollmod != null) {
            this.randomProp(prop, GlobalService.Roll(10) - rollmod);
        }
        else {
            this.randomProp(prop);
        }
    }

    async openOptions(prop,multi=false) {
        var options = this.dataset[prop];
        
        const modal = await this.modalController.create({
            component: SelectLifepathPage,
            componentProps: {options:options}
        });
        await modal.present();
        const { data } = await modal.onDidDismiss();
        if (data) {
            if (multi) {
                this.character.lifepath[prop].push(data);
            }
            else {
                this.character.lifepath[prop] = data;
            }
        }
    }

    select(prop,multi=false) {
        this.openOptions(prop,multi);
    }
    close() {
        this.modalController.dismiss();
    }

}
